import React from "react";
import { StatTile } from "@/features/daily/components/StatTile";
import type { StatTileVm } from "@/features/daily/components/stat-tile-view-model";

type Props = {
    title: string;
    tiles: StatTileVm[];
};

/** D106: the selected day at a glance — identical tiles; detail and reasons in each tooltip. */
export const DaySummaryCards: React.FC<Props> = ({ title, tiles }) => (
    <section aria-label={title}>
        <ul className="daily-tiles daily-day-tiles">
            {tiles.map((tile) => <StatTile key={tile.key} tile={tile} idPrefix="daily-day-tip" />)}
        </ul>
    </section>
);
